export default __webpack_public_path__ + "static/media/header.68ebed1d.png";